export const COOKIE_CONSENT_ACCEPTED = 'accepted';
export const COOKIE_CONSENT_REJECTED = 'rejected';

const STORAGE_KEY = 'meteris_cookie_consent';
const CONSENT_TTL_MS = 180 * 24 * 60 * 60 * 1000;

function isBrowser() {
  return typeof window !== 'undefined';
}

export function getCookieConsent() {
  if (!isBrowser()) {
    return null;
  }

  try {
    const rawValue = window.localStorage.getItem(STORAGE_KEY);

    if (!rawValue) {
      return null;
    }

    const parsedValue = JSON.parse(rawValue);
    const isKnownStatus =
      parsedValue?.status === COOKIE_CONSENT_ACCEPTED ||
      parsedValue?.status === COOKIE_CONSENT_REJECTED;

    if (!isKnownStatus || typeof parsedValue.updatedAt !== 'number') {
      window.localStorage.removeItem(STORAGE_KEY);
      return null;
    }

    if (Date.now() - parsedValue.updatedAt > CONSENT_TTL_MS) {
      window.localStorage.removeItem(STORAGE_KEY);
      return null;
    }

    return parsedValue.status;
  } catch (_error) {
    // L'accès même au stockage peut lever (SecurityError) : ne jamais faire tomber l'application.
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch (_ignore) {
      // rien à nettoyer
    }
    return null;
  }
}

export function saveCookieConsent(status) {
  if (!isBrowser()) {
    return false;
  }

  // Un navigateur peut refuser l'écriture (données de site bloquées, quota, mode privé ancien) :
  // le choix vaut alors pour la session et la bannière doit quand même pouvoir se fermer.
  try {
    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        status,
        updatedAt: Date.now(),
      }),
    );
    return true;
  } catch (_error) {
    return false;
  }
}
